import moment from 'moment';

export default value => /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/.test(value)
    && moment(value, 'YYYY-MM-DD', true).isValid();
